import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WebsiteRelatedContentComponent } from './website-related-content.component'
import { SharedModule } from '../shared/shared.module'
import { PipesModule } from '../../pipes/pipes.module'

@NgModule({
  imports: [CommonModule, SharedModule, PipesModule],
  declarations: [WebsiteRelatedContentComponent],
  exports: [WebsiteRelatedContentComponent],
  providers: [],
})
export class WebsiteRelatedContentModule {
}
